import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { lightPalette } from "../../theme-layout/palette";
import { Box, Paper, Typography } from "@mui/material";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const details = payload[0].payload;
    return (
      <Box component={Paper} padding={1.5}>
        <Typography variant="body1" fontWeight="600">
          {label}
        </Typography>
        <Typography variant="body1">
          Total Count: <strong>{details?.count}</strong>
        </Typography>
        {details.cities !== null &&
          Object.entries(details.cities).map(([city, clients]) => (
            <div key={city} style={{ marginTop: 4 }}>
              <Typography variant="body1" fontWeight="600">
                {city}
              </Typography>
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {clients !== null &&
                  clients.map((c, i) => (
                    <li key={i}>
                      <Typography variant="body1">
                        {c.clientName} –{" "}
                        <strong>{c.totalForecastHours?.toFixed(2)} hrs</strong>
                      </Typography>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
      </Box>
    );
  }
  return null;
};

export default function ForecastAnalysis({ data }) {
  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart
        data={data}
        margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
      >
        <CartesianGrid
          stroke={lightPalette.default.lighter}
          vertical={false}
          strokeDasharray="3 3"
        />
        <XAxis
          tick={{
            fill: lightPalette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            dy: 8,
          }}
          axisLine={{ stroke: lightPalette.default.lighter }}
          tickLine={{ stroke: lightPalette.default.lighter }}
          dataKey="date"
        />
        <YAxis
          tick={{
            fill: lightPalette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            dx: -8,
          }}
          axisLine={{ stroke: lightPalette.default.lighter }}
          tickLine={{ stroke: lightPalette.default.lighter }}
          allowDecimals={false}
        />
        <Tooltip
          wrapperStyle={{ zIndex: 9, pointerEvents: "auto" }}
          content={<CustomTooltip />}
        />
        <Line
          type="monotone"
          dataKey="count"
          stroke={lightPalette.primary.main}
          strokeWidth={3}
          dot={{ r: 5 }}
          activeDot={{ r: 7 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}